export var isNative = false;
//# sourceMappingURL=isNative.js.map